(() => {
  const isSpanish = document.documentElement.lang.toLowerCase().startsWith('es');
  const isPlaceholder = (source) => {
    try {
      const url = new URL(source, location.origin);
      return url.hostname === 'images-na.ssl-images-amazon.com'
        && url.pathname === '/images/G/01/x-locale/common/grey-pixel.gif';
    } catch { return false; }
  };
  const setLabel = (node, name, value) => {
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  };
  const cleanReviewImages = new WeakMap();
  const hidePlaceholder = (node) => {
    if (node.hidden !== true) node.hidden = true;
    if (node.style.getPropertyValue('display') !== 'none' || node.style.getPropertyPriority('display') !== 'important') {
      node.style.setProperty('display', 'none', 'important');
    }
  };
  const refresh = () => {
    // Work only on the browser's Appio copy; the original reviews stay in Appio.
    (window.Appio?.reviews || []).forEach((review) => {
      if (typeof review.images === 'string' && cleanReviewImages.get(review) !== review.images) {
        const images = review.images.split(',').filter((url) => url && !isPlaceholder(url.trim())).join(',');
        if (review.images !== images) review.images = images;
        cleanReviewImages.set(review, images);
      }
    });
    document.querySelectorAll('.appio-review-item-media-box, .appio-detail-review-box, .appio-swiper-media').forEach((box) => {
      box.querySelectorAll('img').forEach((image) => {
        if (isPlaceholder(image.dataset.src || image.getAttribute('src'))) {
          hidePlaceholder(image);
          setLabel(image, 'aria-hidden', 'true');
          const slide = image.closest('.swiper-slide');
          if (slide && (slide.style.getPropertyValue('display') !== 'none' || slide.style.getPropertyPriority('display') !== 'important')) {
            slide.style.setProperty('display', 'none', 'important');
          }
        } else {
          setLabel(image, 'alt', isSpanish ? 'Foto del cliente en su reseña' : 'Customer review photo');
        }
      });
      if (box.matches('.appio-review-item-media-box')) {
        const hasMedia = [...box.querySelectorAll('img, video')].some((media) => !media.hidden)
          || !!box.querySelector('[class*="video"]');
        if (box.hidden !== !hasMedia) box.hidden = !hasMedia;
        if (!hasMedia) {
          if (box.dataset.yxPlaceholderOnly !== 'true') box.dataset.yxPlaceholderOnly = 'true';
          if (box.style.getPropertyValue('display') !== 'none' || box.style.getPropertyPriority('display') !== 'important') {
            box.style.setProperty('display', 'none', 'important');
          }
        } else if (box.dataset.yxPlaceholderOnly) {
          delete box.dataset.yxPlaceholderOnly;
          if (box.style.getPropertyValue('display')) box.style.removeProperty('display');
        }
      }
    });
    document.querySelectorAll('.appio-powered-by img').forEach((image) => setLabel(image, 'alt', 'Appio'));
    document.querySelectorAll('a.appio-powered-by, .appio-powered-by a').forEach((link) => setLabel(link, 'aria-label', isSpanish ? 'Reseñas con Appio' : 'Reviews powered by Appio'));
    if (isSpanish) {
      document.querySelectorAll('.appio-swiper-media .swiper-button-next').forEach((node) => setLabel(node, 'aria-label', 'Imagen siguiente'));
      document.querySelectorAll('.appio-swiper-media .swiper-button-prev').forEach((node) => setLabel(node, 'aria-label', 'Imagen anterior'));
    }
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; refresh(); });
  };
  refresh();
  new MutationObserver((records) => {
    if (records.some((record) => record.type === 'childList' || record.target.closest?.('[class*="appio"]'))) schedule();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'data-src', 'aria-label'] });
})();
